export interface QrScanModalProps {
  className?: string;
  onCloseCallback: () => void;
}

export enum MediaTrackConstraints {
  environment = 'environment',
  user = 'user',
}
